<template>
	<div style="background-color: #fff;margin: 10px;border-radius: 3px;">
		<div style="position: sticky;top:0;z-index: 999;background-color: #fff;padding-bottom: 1px;border-bottom: 1px solid #ebeef5;padding-top: 10px;">
			<!--带折叠的搜索start-->
			<div>
				<el-form size="mini" style="display: flex;flex-wrap: wrap;padding-left: 8px;" :style="{'height':isShowCollapse?'auto':'50px'}" ref="searchForm" :model="searchForm" inline label-width="150px">

					<!--收起时显示的搜索项start 4个搜索项为一行-->
					<div v-show="!isShowCollapse" style="width: 80%;display: flex;">

						<el-form-item v-if="role=='hq_admin'" label="门店" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>
						
						<el-form-item v-if="role=='store_admin'||role=='store_sa'" label="教练id" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.admin_id" clearable placeholder="请选择">
						
								<el-option v-for="item in storeAdminUserList" :label="item.nickname" :value="item.id">
						
									<div style="display: flex;align-items: center;">
										<img :src="item.avatar" style="width: 30px;height: 30px;margin-right: 10px;border-radius: 50%;" />
										<span style="float: left">{{ item.nickname }}</span>
									</div>
						
						
								</el-option>
						
							</el-select>
						</el-form-item>

						<el-form-item label="状态" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.status" clearable placeholder="请选择">
							
								<el-option label="草稿" :value="0" />
								<el-option label="发布" :value="1" />
							</el-select>
						</el-form-item>
						
						<el-form-item label="描述" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.description" placeholder="" clearable size="mini"  />
						</el-form-item>
						
						<el-form-item label="类型" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.type" clearable placeholder="请选择">
								<!-- 类型 (1: 精彩图片, 2: 生日专区, 3: 今日懿宝贝) -->
								<el-option label="精彩图片" :value="1" />
								<el-option label="生日专区" :value="2" />
								<el-option label="今日懿宝贝" :value="3" />
							</el-select>
						</el-form-item>

						
						


					</div>
					<!--收起时显示的搜索项end-->

					<!--展开时显示的搜索项start 4个搜索项为一行-->
					<div v-if="isShowCollapse" style="display: flex;flex-wrap: wrap;">


						<el-form-item v-if="role=='hq_admin'" label="门店" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>
						
						<el-form-item v-if="role=='store_admin'||role=='store_sa'" label="教练id" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.admin_id" clearable placeholder="请选择">
						
						
						
								<el-option v-for="item in storeAdminUserList" :label="item.nickname" :value="item.id">
						
									<div style="display: flex;align-items: center;">
										<img :src="item.avatar" style="width: 30px;height: 30px;margin-right: 10px;border-radius: 50%;" />
										<span style="float: left">{{ item.nickname }}</span>
									</div>
						
						
								</el-option>
						
							</el-select>
						</el-form-item>



						<el-form-item label="状态" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.status" clearable placeholder="请选择">
								
								<el-option label="草稿" :value="0" />
								<el-option label="发布" :value="1" />
								
							</el-select>
						</el-form-item>
						
						<el-form-item label="描述" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.description" placeholder="" clearable size="mini" />
						</el-form-item>
						
						<el-form-item label="类型" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.type" clearable placeholder="请选择">
								<!-- 类型 (1: 精彩图片, 2: 生日专区, 3: 今日懿宝贝) -->
								<el-option label="精彩图片" :value="1" />
								<el-option label="生日专区" :value="2" />
								<el-option label="今日懿宝贝" :value="3" />
							</el-select>
						</el-form-item>

						
						<el-form-item label="日期" style="width: 29%;display: flex;">
							<div slot="label" style="width: 105px;text-align: right;">日期</div>
							<el-date-picker style="margin-left: 8px;" v-model="searchForm.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
						</el-form-item>

					</div>
					<!--展开时显示的搜索项end-->

					<div :style="{'width':isShowCollapse?'100%':'13%','justify-content': isShowCollapse?'flex-end':'center','margin-left':isMobile?'20px':'' }" style="height: 30px; display: flex;margin: 0;margin-bottom: 10px;">
						<div style="flex-shrink: 0;margin-right: 20px;display: flex;justify-content: center;align-items: center;cursor:pointer;color: #9A7E9C;font-size: 14px;line-height: 20px; display: flex;margin-left: 20px;" @click="isShowCollapseF()">
							<span v-if="!isShowCollapse">展开</span>
							<span v-else>收起</span>
							<span style="margin-left: 5px;font-size: 20px;line-height: 20px;" :style="{transform:isShowCollapse?'rotate(180deg)':'rotate(0deg)'}">∨</span>
						</div>
						<el-button round style="margin-right: 10px;" @click="handleSearch" type="primary" icon="el-icon-search" size="small">搜索</el-button>
						<el-button round @click="handleReset" size="small">重置</el-button>
						<div v-if="isShowCollapse" style="width: 70px;"></div>
					</div>


				</el-form>
			</div>
			<!--带折叠的搜索end-->

			<!-- 只允许单选的排序start -->
			<div style="margin-top: 10px;display: flex;align-items: center;background-color: #fff;margin-bottom: 10px; justify-content: space-between;">

				<div style="margin-right: 20px;margin-left: 15px;display: flex;align-items: center;">
					<div>
						<el-button style="width:75px;" type="primary" round size="mini" @click="showAddOrEdit('','add')">添加</el-button>
						
						<el-button type="success" round size="mini" @click="handleReset" style="margin-left: 20px;">全部</el-button>
						<el-button style="margin-left: 20px;" type="warning" round size="mini" @click="pingLunSh">评论待查看</el-button>
						<el-button style="margin-left: 20px;" type="warning" round size="mini" @click="huiFuSh">评论待回复</el-button>
						
					</div>
				</div>

				<div class="sortLine" style="font-size: 14px;display: inline-flex; margin-left: 40px; color: #6f6c5f;background-color: #e0f7ed;border-radius: 8px;overflow: hidden;margin-right: 68px;">

					<div class="sortItem dis" @click="sort(-1)" :style="{color: sortIndex==-1?'#fff':'#777','font-weight': sortIndex==-1?'bold':'400','background-color': sortIndex==-1?'#9E819F':''}">
						默认</div>
					<!-- 排序项start -->
					<div class="sortItem dis" @click="sort(0,'create_time')" :style="{color: sortIndex==0?'#fff':'#777','font-weight': sortIndex==0?'bold':'400','background-color': sortIndex==0?'#9E819F':''}">
						日期
						<img v-if="sortIndex==0&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==0&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>
					<!-- 排序项end -->
					<div class="sortItem dis" @click="sort(1,'like_count')" :style="{color: sortIndex==1?'#fff':'#777','font-weight': sortIndex==1?'bold':'400','background-color': sortIndex==1?'#9E819F':''}">
						点赞数量
						<img v-if="sortIndex==1&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==1&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>
					
					<div class="sortItem dis" @click="sort(2,'remark_count')" :style="{color: sortIndex==2?'#fff':'#777','font-weight': sortIndex==2?'bold':'400','background-color': sortIndex==2?'#9E819F':''}">
						评论数量
						<img v-if="sortIndex==2&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==2&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>
					
					<div class="sortItem dis" @click="sort(3,'remark_time')" :style="{color: sortIndex==3?'#fff':'#777','font-weight': sortIndex==3?'bold':'400','background-color': sortIndex==3?'#9E819F':''}">
						评论时间
						<img v-if="sortIndex==3&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==3&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>

				</div>


			</div>
			<!-- 只允许单选的排序end -->

		</div>






		<!--表格start :height="tableHeight+'px'"-->
		<el-table :height="tableHeight" :show-header="false" ref="table" :data="tableData" style="width: 100%;background-color: #fff;margin: 5px;">

			<el-table-column style="width: 100%;">
				<template slot-scope="{ row, index }">
					<div class="tableTem" style="display: flex;">


						<div class="avatar" style="padding-right: 0;">

							<!--用户图片start-->
							<div style="text-align: center;margin-right: 30px;" class="dis">
								<img :src="row.image" style="width:70px;height:70px;cursor: pointer;" @click="handlePreView(row.image)">
								<!-- <div class="titleFont">主图</div> -->
							</div>
							<!--用户图片end-->

							<!-- <div style="width: 110px;">

							
								<div style="display: flex;">
									<span class="titleFont" style="width: 50px;text-align: right;">id：</span>
									<el-tooltip :content="row.id+''" placement="right">
										<div class="dian dianL">{{row.id}}</div>
									</el-tooltip>
								</div>
								
								<div style="display: flex;margin-top: -6px;">
									<span class="titleFont" style="width: 50px;text-align: right;">状态：</span>
								
									<div v-if="row.status==0" class="dian dianL" style="color: red;font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
										<div style="width: 10px;height: 10px;background-color: red;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
										草稿
									</div>
									<div v-if="row.status==1" class="dian dianL" style="color: rgb(103, 194, 58);font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
										<div style="width: 10px;height: 10px;background-color: rgb(103, 194, 58);border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
										发布
									</div>

								</div>
								
		
							</div> -->
							
						</div>


						<!-- height: 50px; -->
						<ul :style="{'width':isMobile?mobileWidth+'px':'','overflow-x':isMobile?'auto':'','overflow-y':isMobile?'hidden':'','flex-wrap':isMobile?'nowrap':''}">
							
							
							
							<li>
								<div class="content dis" style="min-height: 40px;">
									
									<div v-if="row.status==0" class="dian" style="color: red;">草稿</div>
									<div v-if="row.status==1" class="dian" style="color: rgb(103, 194, 58);">发布</div>
									
								</div>
								<div class="titleFont">状态</div>
							</li>
							
							<li>
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.id+''" placement="right">
										<div class="dian">{{row.id}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">id</div>
							</li>
							
							
							
							<li>
								<div class="content dis" style="min-height: 40px;">
							
									<img :src="row.images[0]" style="width:30px;cursor: pointer;border-radius: 3px;" @click="handlePreView(row.images)">
							
								</div>
								<div class="titleFont dian">轮播图</div>
							</li>
							
							
							<li>
								<div class="content dis" style="min-height: 40px;">
									
									<div v-if="row.type==1" class="dian">精彩图片</div>
									<div v-if="row.type==2" class="dian">生日专区</div>
									<div v-if="row.type==3" class="dian">今日懿宝贝</div>
									
								</div>
								<div class="titleFont">类型</div>
							</li>
							
							<li>
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.description?row.description+'':'无'" placement="right">
										<div class="dian">{{row.description?row.description+'':'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">描述</div>
							</li>
							
							<li>
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.like_count+''" placement="right">
										<div class="dian">{{row.like_count}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">喜欢数量</div>
							</li>
							
							<li>
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.remark_count+''" placement="right">
										<div class="dian">{{row.remark_count}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">评论数量</div>
							</li>
							
							<li>
							
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.new_remark?row.new_remark+'':0+''" placement="right">
										<div class="dian">{{row.new_remark?row.new_remark:0}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">待读评论</div>
							</li>
							
							
			
							<li >
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.store?row.store.name:'无'" placement="right" style="">
										<div class="dian" style="padding-left: 10px;padding-right: 10px;">{{row.store?row.store.name:'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">门店名称</div>
							</li>

							<li>
								<div class="content dis" style="min-height: 40px;">

									<img :src="row.admin?row.admin.avatar:''" style="width:30px;cursor: pointer;border-radius: 3px;" @click="handlePreView(row.admin?row.admin.avatar:'')">

								</div>
								<div class="titleFont dian">管理员头像</div>
							</li>
							<li>
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.admin?row.admin.nickname:'无'" placement="right">
										<div class="dian">{{row.admin?row.admin.nickname:'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">管理员昵称</div>
							</li>


							<!-- <li>
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.description?row.description+'':'无'" placement="right" >
										<div class="dian">{{row.description?row.description:'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">描述</div>
							</li> -->


							<li>
								<!--  | timeBreak1 -->
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.create_time+''" placement="right">
										<div class="content dis" style="flex-direction: column;line-height: 16px;">
											<div>{{row.create_time | timeBreak1}}</div>

										</div>

									</el-tooltip>
								</div>
								<div class="titleFont dian">创建时间</div>
							</li>


						</ul>


						<div  style="width: 100px;display: flex;justify-content: start;align-items: center;margin-left: 10px;">
							<el-dropdown trigger="hover" style="width: 80px;">
								<el-button size="mini" round type="primary">
									操作<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">

									<el-dropdown-item>
										<el-button type="success" size="mini" round @click="showDetail(row)">查看
										</el-button>
									</el-dropdown-item>
									<!-- <el-dropdown-item v-if="role=='store_admin'||role=='store_sa'">
										<el-button type="danger" size="mini" round @click="delSK(row.id)">删除
										</el-button>

									</el-dropdown-item> -->

									<el-dropdown-item>
										<el-button  type="danger" size="mini" round @click="showAddOrEdit(row,'edit')">编辑
										</el-button>
									</el-dropdown-item>


								</el-dropdown-menu>
							</el-dropdown>

						</div>




					</div>

				</template>
			</el-table-column>
		</el-table>
		<!--表格end-->

		<!--分页start-->
		<el-row type="flex" justify="end" align="middle" class="page" style="margin-top: 10px;margin-right: 50px;padding-bottom: 10px;">
			<el-pagination background layout="prev, pager, next" :current-page="pageNumber" :page-size="pageSize" :total="total" @current-change="changePage"></el-pagination>
			<span style="font-size: 13px;color: #999;">共 {{total}} 条</span>
		</el-row>
		<!--表格end-->

		<!--浏览图片的弹窗start-->
		<el-dialog :close-on-click-modal="false" width="540px"  title="预览" :visible.sync="isShowPreImg">
			
			<div style="width:500px;max-height: 500px;overflow: auto;">
				<img v-for="(item,index) in preImgUrl" :src="item" style="width: 100%">
			</div>
			
		</el-dialog>
		<!--浏览图片的弹窗end-->


		<!--详情的弹窗start-->
		<el-dialog :close-on-click-modal="false" class="detal" width="70%" title="详情" :visible.sync="isShowDetail">
			<div v-if="isShowDetail" class="order-detail" style="padding: 0 50px 50px 50px;">
				
						<div class="contentOne-content">
							<div  class="contentOne-content-title">创建时间：</div>
							<div  class="contentOne-content-text text-num">{{currentRow.create_time}}</div>
						</div>

						<div class="contentOne-content">
							<div  class="contentOne-content-title" style="margin-left: 2em;">状态：</div>
							<div v-if="currentRow.status==0" class="contentOne-content-text text-num" style="color:red;">草稿</div>
							<div v-if="currentRow.status==1" class="contentOne-content-text text-num" style="color:rgb(103, 194, 58);">发布</div>
						</div>
						<div class="contentOne-content">
							<div  class="contentOne-content-title" style="margin-left: 3em;">id：</div>
							<div  class="contentOne-content-text text-num">{{currentRow.id}}</div>
						</div>
						
						<div class="contentOne-content">
							<div  class="contentOne-content-title" style="margin-left: 2em;">封面：</div>
							<div  class="contentOne-content-text text-num"> <img :src="currentRow.image" @click="handlePreView(currentRow.image)" style="width: 50px;height: 50px;border-radius: 5px;cursor: pointer;"/>  </div>
						</div>
						
						<div class="contentOne-content">
							<div  class="contentOne-content-title" style="margin-left: 1em;">轮播图：</div>
							<div  class="contentOne-content-text text-num"> <img v-for="(item,index) in currentRow.images" :src="item" @click="handlePreView(item)" style="width: 50px;height: 50px;border-radius: 5px;cursor: pointer;margin-right:10px;"/>  </div>
						</div>
						
						<div class="contentOne-content">
							<div  class="contentOne-content-title" style="margin-left: 2em;">描述：</div>
							<div  class="contentOne-content-text text-num">{{currentRow.description}}</div>
						</div>
						
						<div class="contentOne-content">
							<div  class="contentOne-content-title" style="margin-left: 2em;">类型：</div>
							<!-- 类型 (1: 精彩图片, 2: 生日专区, 3: 今日懿宝贝) -->
							<div v-if="currentRow.type==1" class="contentOne-content-text text-num">精彩图片</div>
							<div v-if="currentRow.type==2" class="contentOne-content-text text-num">生日专区</div>
							<div v-if="currentRow.type==3" class="contentOne-content-text text-num">今日懿宝贝</div>
						</div>
						
						<div class="contentOne-content">
							<div  class="contentOne-content-title">喜欢数量：</div>
							<div  class="contentOne-content-text text-num">{{currentRow.like_count}}</div>
						</div>
						<div class="contentOne-content">
							<div  class="contentOne-content-title">评论数量：</div>
							<div  class="contentOne-content-text text-num">{{currentRow.remark_count}}</div>
						</div>
						
						<div class="contentOne-content">
							<div  class="contentOne-content-title">待读评论：</div>
							<div  class="contentOne-content-text text-num">{{currentRow.new_remark?currentRow.new_remark+'':0}}</div>
						</div>
						
						<div class="contentOne-content">
							<div  class="contentOne-content-title">门店名称：</div>
							<div  class="contentOne-content-text text-num"> {{currentRow.store?currentRow.store.name:'无'}} </div>
						</div>
						
						<div class="contentOne-content">
							<div  class="contentOne-content-title">门店图片：</div>
							<div  class="contentOne-content-text text-num"> <img v-if="currentRow.store" :src="currentRow.store.image" @click="handlePreView(currentRow.store.image)" style="width: 50px;height: 50px;border-radius: 5px;cursor: pointer;"/><div>无</div>  </div>
						</div>
						
						<div class="contentOne-content">
							<div  class="contentOne-content-title" style="margin-left: -1em;">管理员名称：</div>
							<div  class="contentOne-content-text text-num"> {{currentRow.admin?currentRow.admin.nickname:'无'}} </div>
						</div>
						
						<div class="contentOne-content">
							<div  class="contentOne-content-title" style="margin-left: -1em;">管理员头像：</div>
							<div  class="contentOne-content-text text-num"> <img :src="currentRow.admin?currentRow.admin.avatar:''" @click="handlePreView(currentRow.admin?currentRow.admin.avatar:'')" style="width: 50px;height: 50px;border-radius: 5px;cursor: pointer;"/>  </div>
						</div>
						

						<div class="contentOne-content">
							<div  class="contentOne-content-title">喜欢列表：</div>
							<div  class=" contentOne-content-text text-num" style="display: flex;align-items: center;flex-wrap: wrap;"> 
								<div  v-for="(item,index) in currentRow.like" class="dis" style="flex-direction: column;margin-right:10px;margin-bottom: 10px;">  
									<img :src="item.avatar" @click="handlePreView(item.avatar)" style="width: 50px;height: 50px;border-radius: 5px;cursor: pointer;"/> 
									<el-tooltip :content="item.nickname+''" placement="right">
										<div style="width:50px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align: center;font-size: 13px;margin-top: 3px;">{{item.nickname}}</div> 
									</el-tooltip>
								</div> 

								<div v-if="currentRow.like.length==0" style="color:#aaa;">暂无信息~</div>
								
							</div>
						</div>


						<!-- 评论列表start -->
						<div class="contentOne-content">
							<div class="contentOne-content-title">用户评论：</div>
							<div  class="contentOne-content-text text-num"> 
								<div v-if="currentRow.remark.length==0" style="color:#aaa;">暂无信息~</div>
							</div>
							
						</div>

	
						<!-- 评论列表start -->
						<div style="margin-left: 5em;">
						
							<div v-for="(item,index) in currentRow.remark">

								<div>
									<!-- 顶级评论start -->
									<div class="dis" style="margin-bottom: 10px;justify-content: flex-start;margin-top: 20px;">

										<img v-if="item.user" :src="item.user.avatar" style="flex-shrink: 0;width: 30px;height: 30px;background: #DDDDDD;border-radius: 50%;margin-right:10px;"></img>
										<img v-if="item.admin" :src="item.admin.avatar" style="flex-shrink: 0;width: 30px;height: 30px;background: #DDDDDD;border-radius: 50%;margin-right:10px;"></img>
										<div v-if="item.user" style="font-family: Source Han Sans CN;font-weight: 500; color: rgb(164, 164, 164);">{{item.user.nickname}}</div>
										<div v-if="item.admin" style="font-family: Source Han Sans CN;font-weight: 500; color: rgb(164, 164, 164);">{{item.admin.nickname}}</div>
										
									</div>


									<div style="margin-left:40px; width: 570px; color: rgb(164, 164, 164);display: flex;align-items: flex-end;justify-content: space-between;">

										{{item.remark}}
									</div>
									<div style="margin-left:40px;display: flex;justify-content: flex-end;align-items: center;">
										<div style="font-size: 13px; font-family: Source Han Sans CN;font-weight: 400; color: rgb(164, 164, 164);flex-shrink: 0;margin-right: 30px;">{{item.create_time}}</div>
									
										<div v-if="item.remark !='该条评论已被删除'" @click="showPingLunPop(1,item)" style="flex-shrink: 0; color: rgb(164, 164, 164);padding-right: 20px;cursor: pointer;">回复</div>
										
										<div v-if="item.remark !='该条评论已被删除'" @click="delPingLunPop(item.id,item.remark)" style="flex-shrink: 0; color: rgb(164, 164, 164);padding-right: 20px;cursor: pointer;">删除</div>
										
									
									</div>
									<!-- 顶级评论end -->
									
									<!-- 用户回复的列表start -->
									<div  style="margin-left:38px;border-radius: 10px;margin-top: 10px;padding-top: 0;" :style="item.reply.length==0?'background-color: #fff;padding:0;':'background-color: #f8f8f8;padding: 20px;'">
										
										<div v-for="(item2,index) in item.reply">
										<div class="dis" style="margin-bottom: 10px;justify-content: flex-start;padding-top: 20px;">
										
											
											<div style="display: flex;justify-content: space-between;width: 100%;padding-right: 10px;">
												<div style="display: flex;align-items: center;">
													<img v-if="item2.user" :src="item2.user.avatar" style="flex-shrink: 0;width: 30px;height: 30px;background: #DDDDDD;border-radius: 50%;margin-right:10px;"></img>
													<img v-if="item2.admin" :src="item2.admin.avatar" style="flex-shrink: 0;width: 30px;height: 30px;background: #DDDDDD;border-radius: 50%;margin-right:10px;"></img>
													<div v-if="item2.user" style="font-family: Source Han Sans CN;font-weight: 500; color: rgb(164, 164, 164);">{{item2.user.nickname}}</div>
													<div v-if="item2.admin" style="font-family: Source Han Sans CN;font-weight: 500; color: rgb(164, 164, 164);">{{item2.admin.nickname}}</div>
										
													<div v-if="item2.reply_user||item2.reply_admin" style="display: flex;align-items: center;">
										
														<div style="margin-left: 10px;margin-right: 10px; color: rgb(164, 164, 164);">回复</div>
														
														<img v-if="item2.reply_user" :src="item2.reply_user.avatar" style="flex-shrink: 0;width: 30px;height: 30px;background: #DDDDDD;border-radius: 50%;margin-right:10px;"></img>
														<img v-if="item2.reply_admin" :src="item2.reply_admin.avatar" style="flex-shrink: 0;width: 30px;height: 30px;background: #DDDDDD;border-radius: 50%;margin-right:10px;"></img>
														<div v-if="item2.reply_user" style="font-family: Source Han Sans CN;font-weight: 500; color: rgb(164, 164, 164);">{{item2.reply_user.nickname}}</div>
														<div v-if="item2.reply_admin" style="font-family: Source Han Sans CN;font-weight: 500; color: rgb(164, 164, 164);">{{item2.reply_admin.nickname}}</div>
										
													</div>
										
												</div>
										
											</div>
										</div>
										
										
										<div style="margin-left:40px; width: 570px; color: rgb(164, 164, 164);display: flex;align-items: flex-end;justify-content: space-between;">
										
											{{item2.remark}}
										</div>
										
										<div style="margin-left:40px;display: flex;justify-content: flex-end;align-items: center;">
											<div style="font-size: 13px; font-family: Source Han Sans CN;font-weight: 400; color: rgb(164, 164, 164);flex-shrink: 0;margin-right:30px;">{{item.create_time}}</div>
										
											<div v-if="item2.remark !='该条评论已被删除'" @click="showPingLunPop(2,item,item2)" style="flex-shrink: 0; color: rgb(164, 164, 164);padding-right: 20px;cursor: pointer;">回复</div>
										
											<div v-if="item2.remark !='该条评论已被删除'"  @click="delPingLunPop(item2.id,item2.remark)" style="flex-shrink: 0; color: rgb(164, 164, 164);padding-right: 20px;cursor: pointer;">删除</div>
											
										</div>
										
										
									</div>
									<!-- 用户回复的列表end -->
									
								</div>
							</div>



							</div>


						</div>



						<div class="dis" style="justify-content: flex-start;margin-left: 50px;margin-top: 40px;">
							<el-input type="textarea" :rows="3"  placeholder="请输入评论" v-model="pingLunByAdmin" style="border-radius: 10px;padding: 5px;width:90%;" />

							<div @click="sendMsg" class="dis" style="flex-shrink: 0; margin-left: 10px; color:#fff; cursor: pointer;  width: 60px;height: 30px;background: #907897;border-radius: 10px;">发送</div>

						</div>


					</div>
				



		</el-dialog>
		<!--详情的弹窗end-->


		<!-- 回复的输入框sart -->
		<!-- :modal="false" -->
		<el-dialog :close-on-click-modal="false" width="35%" :title="pingLunInputPlaValue" :visible.sync="isShowPingLunPop" @close="onPingLunPopClose">
			<div style="display: flex;align-items: center;">

				<el-input type="textarea" autosize autofocus :placeholder="pingLunInputPlaValue" v-model="pingLunInputValue" style="border-radius: 10px;padding: 5px;width:80%;" />

				<div @click="sendHuifu" class="dis" style="flex-shrink: 0; margin-left: 10px; color:#fff; cursor: pointer;  width: 60px;height: 30px;background: #907897;border-radius: 10px;">发送</div>

			</div>
		</el-dialog>

		<!-- 回复的输入框end -->



		<!-- 添加或编辑弹窗start -->
		<el-dialog :close-on-click-modal="false" width="600px"  custom-class="m-dialog" title="信息" center :visible.sync="isShowAddOrEdit">
			<div v-if="isShowAddOrEdit">
				<div style="padding-top: 20px;">
		
					<el-form style="margin-left: 80px;" label-width="100px" size="small" ref="form" :rules="formRules" :model="form">
						
						
						
						<el-form-item v-if="role=='hq_admin'" label="门店" >
						<!-- multiple -->
							<el-select clearable v-model="form.store_id"  placeholder="请选择" style="width: 250px;">
								<!-- <el-option label="所有门店" :value="-1" /> -->
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>
						
						<el-form-item label="状态" prop="status">
							<el-select v-model="form.status" clearable placeholder="请选择" style="width: 250px;">
								<!-- 状态 (0: 草稿, 1: 发布) -->
								<el-option label="草稿" :value="0" />
								<el-option label="发布" :value="1" />
							</el-select>
						</el-form-item>
						
						<el-form-item label="类型" prop="type">
							<el-select v-model="form.type" clearable placeholder="请选择" style="width: 250px;">
								<!-- 类型 (1: 精彩图片, 2: 生日专区, 3: 今日懿宝贝) -->
								<el-option label="精彩图片" :value="1" />
								<el-option label="生日专区" :value="2" />
								<el-option label="今日懿宝贝" :value="3" />										
							</el-select>
						</el-form-item>
		
						<el-form-item label="封面" prop="image" style="position: relative;">
							<!-- <div style="position: absolute;top: 20px;left: -59px;font-size: 12px;color: #aaa;">680*910</div> -->
							<upload-img :limit='1'  ref="fengMianUpload" accept="image/*" :imgList="form.image"></upload-img>
							<!-- :imgWidth="680" :imgHeight="910" :limit='1' accept="image/png" fileAfterName=".png"-->
						</el-form-item>
						
						<el-form-item label="轮播图" prop="images" style="position: relative;">
							<!-- <div style="position: absolute;top: 20px;left: -59px;font-size: 12px;color: #aaa;">680*910</div> -->
							<upload-img :limit='600'  ref="swiperUpload" accept="image/*" :imgList="form.images" @uploadSuccess="lunBoImgSuccess"></upload-img>
							<!-- :imgWidth="680" :imgHeight="910" :limit='1' accept="image/png" fileAfterName=".png"-->
						</el-form-item>
						

						<el-form-item label="描述" prop="description">
							<el-input style="width: 250px;" v-model="form.description" placeholder="请输入描述" type="textarea" :rows="5"></el-input>
						</el-form-item>
						
						
		
		
		
					</el-form>
		
				</div>
				<div class="dis" style="justify-content: flex-end;">
		
					<el-button round style="margin-left: 10px" @click="save('form')" type="primary" size="small">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 添加或编辑弹窗end -->

	




		<!-- 全屏透明的loading加载start -->
		<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->


	</div>
</template>

<script>

	import uploadImg from '../../components/upload/uploadImg.vue';
	import {
		ajax
	} from '../../util/ajax.js';

	export default {
		name: '',
		components: {
			uploadImg
		},
		data() {
			return {
				
				
				mobileWidth: window.mobileWidth + 20,
				isMobile: window.isMobile,

				isShowDetail: false,
				currentRow: {},//查看详情的当前行数据
				role: '',

				isShowCollapse: false, //是否展开搜索项
				
				usertime_id:'',//修改的id
				isShowAddOrEdit: false,
				searchForm: {
					
				},

				

				


				storeList:[],//门店列表

				pingLunByAdmin: '',
				isShowPingLunPop: false,
				pingLunInputValue: '', //评论的输入框内容
				pingLunInputPlaValue: '', //评论的输入框提示文字
				currentSentMsgItem: '',//这个是回复用户列表中的item2
				huifuDingJiItem1:'',//这个是顶级的item
				huifuType:'',//回复类别，1为回复顶级，2为回复用户

				isShowPreImg: false, //是否显示浏览图片的弹窗
				preImgUrl: '', //浏览图片弹窗的图片地址


				tableHeight: 0, //表格高度
				loading: false,
				tableData: [], //表格数据
				pageNumber: 1, // 当前页数
				pageSize: 10, // 页面大小
				total: 0,

				shang: require("@/assets/shang.png"),
				xia: require("@/assets/xia.png"),
				sortIndex: -1, //排序项
				sortContent: '', //排序项的值 desc 或esc
				sortFlag: true, //排序箭头切换


				typeOptions: [], //分类列表
				currentStartNum: '',
				currentEidtRow: '',
				storeAdminUserList: [], //门店管理员列表
				
				
				form: {
					store_id:'',
					image: [],
					images:[],
					description:'',
					type:'',
					status:'',
				},
				formRules: {
					
					image: [{
						type: 'array',
						required: true,
						message: '请上传封面',
						trigger: 'change'
					}],
					images: [{
						type: 'array',
						required: true,
						message: '请上传轮播图',
						trigger: 'change'
					}],
				
					description: [{
						required: true,
						message: '请输入描述',
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: '请选择类型',
						trigger: 'blur'
					}],
					status: [{
						required: true,
						message: '请选择状态',
						trigger: 'blur'
					}],
					
					
				},
				
				
			}
		},

		filters: {
			//把 2021-07-30 11:07:36 格式为 07-30
			//								11:07
			//使用格式 <p>{{row.stateChangeTime | timeBreak(0)}}</p>    <p>{{row.stateChangeTime | timeBreak(1)}}</p> 
			timeBreak(time, type, from) {
				if (time) {
					return type == 0 ? (from == undefined ? time.substr(5, 5) : time.substr(0, 10)) : (type == 2 ? time
					.substr(0, 10) : (from == undefined ? time.substr(11, 5) : time.substr(11, 8)));
				} else {
					return time;
				}
			},

			timeBreak2(val) {

				let v = val.split(' ')[1];

				return v;
			},
			timeBreak1(val) {

				let v = val.split(' ')[0];

				return v;
			},

		},
		created() {
			this.getTableHeight();
		},
		mounted() {
			this.role = localStorage.getItem("role") ? localStorage.getItem("role").replace(/3alxi2fdksjfkljwijljsk128ldfln324kodnvjdsl32432jfiwefjls32432idaxpoife983iw2/g, '') : ''; //获取当前用户角色
			//挂载window.onresize事件(动态设置table高度)
			let _this = this;
			window.onresize = () => {
				if (_this.resizeFlag) {
					clearTimeout(_this.resizeFlag);
				}
				_this.resizeFlag = setTimeout(() => {
					_this.getTableHeight();
					_this.resizeFlag = null;
				}, 100);
			};
			if (this.role == 'hq_admin') {
				this.getStore();//门店列表
			}

			

			if (this.role == 'store_admin'||this.role=='store_sa') {
				this.getStoreList();//教练列表
			}
			
			this.initData();


		},

		methods: {
			
			//获取门店列表
			async getStore() {
				let ress = await ajax('/hq/store', 'GET');
				let res = ress.data.data;
				this.storeList = res.store;
				console.log('this.storeList',this.storeList)
			},
			
			//初始化表格数据
			async initData() {
				this.loading = true
				var searchForm = this.searchForm
				if (searchForm.store_id === "") { //select未选中为空字符串
					searchForm.store_id = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.admin_id === "") { //select未选中为空字符串
					searchForm.admin_id = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.description === "") { //select未选中为空字符串
					searchForm.description = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.type === "") { //select未选中为空字符串
					searchForm.type = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.status === "") { //select未选中为空字符串
					searchForm.status = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.date === "" || searchForm.date ===null) { //select未选中为空字符串
					searchForm.date = undefined; //为null后就不会作为http请求参数了带给后端了
				}
		
			
				if (searchForm.date && searchForm.date.length > 0) {
					//日期重新赋值为时间戳日期
					let arr = searchForm.date;
					if (arr[0].getTime) {
						searchForm.date = [arr[0].getTime(), arr[1].getTime()];
					} else {
						searchForm.date = arr;
					}
				}
				
				if (searchForm.sort==="") {
					searchForm.sort = undefined; //排序的属性名
					searchForm.rule = undefined; //排序的方式
				}
			
				let param = {
					...searchForm,
					count: this.pageSize,
					page: this.pageNumber
				}
			
				
			
				let ress = await ajax('/usertime/image/list', 'POST', param);
				this.loading = false;
				let res = ress.data.data;
				this.total = res.total;
				this.tableData = res.list;
			},
			

			async getStoreList() {
				let res = await ajax('/store/admin/list', 'GET', {
					page: 1,
					count: 10000
				});
				this.storeAdminUserList = res.data.data.admin;
			},


			//发送评论
			async sendMsg() {


				if (!this.pingLunByAdmin) {
					this.$message.error('请输入评论内容');
					return;
				}

				console.log('this.currentRow', this.currentRow)
				let param = {
					usertime_id: this.currentRow.id,
					remark: this.pingLunByAdmin,
				};
				

				this.loading = true;
				let res = await ajax('/usertime/image/remark', 'POST', param);
				this.pingLunByAdmin = "";
				this.loading = false;
				this.$message({
					type: 'success',
					message: '评论成功'
				});
				this.showDetail(this.currentRow);




			},

			kePingSh() {
				this.searchForm.video_status = "";
				this.searchForm.admin_id = "";
				this.searchForm.status = 0;
				this.searchForm.new_remark = "";
				this.searchForm.no_reply_remark = "";
				this.handleSearch();

			},

			shipinSh() {
				this.searchForm.status = "";
				this.searchForm.video_status = 0;
				this.searchForm.new_remark = "";
				this.searchForm.no_reply_remark = "";
				this.handleSearch();
			},

			pingLunSh() {
				
				this.searchForm.new_remark = 1;
				this.searchForm.no_reply_remark = undefined;
				
				this.handleSearch();
			},
			huiFuSh() {
				
				this.searchForm.new_remark = undefined;
				this.searchForm.no_reply_remark = 1;
				
				
				this.handleSearch();
			},
			

			

			

			
			//轮播图上传成功
			lunBoImgSuccess(arr){
				console.log('==>',arr)
			},





			//显示弹出输入框,1为回复顶级，2是回复列表里的用户
			showPingLunPop(type,item,item2) {
				let pingLunInputPlaValue = "";
				this.huifuDingJiItem1 = item;
				this.huifuType=type;
				if(type==1){
					if (item.user) {
						pingLunInputPlaValue = '回复：' + item.user.nickname;
						this.currentSentMsgItem = item;
					
					}
					if (item.admin) {
						pingLunInputPlaValue = '回复：' + item.admin.nickname;
						this.currentSentMsgItem = item;
					}
				}
				if(type==2){
					if (item2.user) {
						pingLunInputPlaValue = '回复：' + item2.user.nickname;
						this.currentSentMsgItem = item2;
					
					}
					if (item2.admin) {
						pingLunInputPlaValue = '回复：' + item2.admin.nickname;
						this.currentSentMsgItem = item2;
					}
				}
				
				
				this.isShowPingLunPop = true;
				this.pingLunInputPlaValue = pingLunInputPlaValue;

			},
			
			
			
			//删除评论,1为回复顶级，2是回复列表里的用户
			async delPingLunPop(remark_id,remark) {
			 
				this.$confirm("确定删除吗？", '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true;
					let ress = await ajax('/usertime/image/remark', 'DELETE', {
						remark,
						remark_id
					});
					this.loading = false;
					this.$message({
						type: 'success',
						message: '成功'
					});
					this.showDetail(this.currentRow);
				}).catch(() => {
					this.loading = false;
				});
			
			},
			
	
			
			
			onPingLunPopClose() {

				this.isShowPingLunPop = false;
				this.pingLunInputValue = ''; //评论的输入框内容
				this.pingLunInputPlaValue = ''; //评论的输入框提示文字
				this.currentSentMsgItem = '';
				this.huifuDingJiItem1 = '';
				this.huifuType='';
			},

			//发送回复
			async sendHuifu() {

				if (!this.pingLunInputValue.trim()) {

					this.$message.error('请输入回复内容');
					return;
				}

				console.log('this.currentRow', this.currentRow)
				let param = {
					usertime_id: this.currentRow.id,
					remark: this.pingLunInputValue,
					parent_id : this.huifuDingJiItem1.id
				};
				

				if (this.currentSentMsgItem.user) {
					param.reply_user_id = this.currentSentMsgItem.user.id;
				}
				if (this.currentSentMsgItem.admin) {
					param.reply_admin_id = this.currentSentMsgItem.admin.id;
				}

				this.loading = true;
				let res = await ajax('/usertime/image/remark', 'POST', param);
				this.onPingLunPopClose();
				this.loading = false;
				this.$message({
					type: 'success',
					message: '回复成功'
				});
				this.showDetail(this.currentRow);

			},

			
			
			//保存弹窗
			async save(formName) {
			
				this.form.image = this.$refs.fengMianUpload.getImgList(); //封面图
				this.form.images = this.$refs.swiperUpload.getImgList(); //轮播图
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let url = 'usertime/image/add';
						
						let arr = [];
						for (let item of this.form.images) {
							arr.push(item.url);
						}
				
						
						let param = {
							
							image: this.form.image[0].url,
							images: arr,
							description:this.form.description,
							type:this.form.type,
							status:this.form.status,
							store_id:this.form.store_id?this.form.store_id:0,
						};
						console.log('this.form.store_id',this.form.store_id)
						
					
						
						let method = "POST";
						if (this.usertime_id) {//编辑
							url = 'usertime/image/edit';
							method = 'PUT';
							param.usertime_id= this.usertime_id;
						}

						this.loading = true;
						let ress = await ajax(url, method, param);
						this.loading = false;
						
						this.$refs[formName].resetFields();
						this.form = {
							store_id:'',
							image: [],
							images:[],
							description:'',
							type:'',
							status:'',
						};
			
						this.$message({
							message: '成功',
							type: 'success'
						});
						this.isShowAddOrEdit = false;
						this.initData();
			
					} else {
						this.$message.error('请填写完整信息');
						return false;
					}
				});
			
			
			
			},
	

			//添加或编辑弹窗,type= add edit
			async showAddOrEdit(row, type) {
				
				if (type == 'edit') {
					this.usertime_id = row.id;
					this.loading = true;
					let ress = await ajax('/usertime/image/detail', 'GET', {
						usertime_id: row.id,
						page:1,
						count:10000
					});
					this.loading = false;
					//回显
					let res = ress.data.data.usertime;
					let arr = [];
					for (let item of res.images) {
						arr.push({url:item});
					}
					this.form.image = [{url:res.image}];
					this.form.images = arr;
					this.form.description = res.description;
					this.form.type = res.type;
					this.form.status = res.status;
					this.form.store_id = res.store_id?res.store_id:"";
				}
				
				if (type == 'add') {
					this.usertime_id = '';
					this.form= {
						store_id:'',
							image: [],
							images:[],
							description:'',
							type:'',
							status:'',
						};
				}


				this.isShowAddOrEdit = true;
			},

			//显示详情
			async showDetail(row) {
				this.loading = true;
				let ress = await ajax('/usertime/image/detail', 'GET', {
					usertime_id: row.id
				});
				this.loading = false;
				let res = ress.data.data.usertime;
				this.currentRow = res;
				this.isShowDetail = true;
			},
			//计算table高度(动态设置table高度)
			getTableHeight() {
				let tableH = 250; //距离页面下方的高度,值越大表格高度越小
				let tableHeightDetil = window.innerHeight - tableH;
				if (tableHeightDetil <= 300) {
					this.tableHeight = 300;
				} else {
					this.tableHeight = window.innerHeight - tableH;
				}
			},


			//展开搜索项
			isShowCollapseF() {
				this.isShowCollapse = !this.isShowCollapse;
			},
			//翻页
			changePage(pageNumber) {
				this.tableData = []; //这种可以让滚动条回到顶部
				this.pageNumber = pageNumber
				this.initData()
			},

			//点击头像
			handlePreView(src) {
				let arr = [];
				if(typeof(src)=='string'){
					arr.push(src);
				}else{
					arr = src
				}
				
				
				this.preImgUrl = arr
				this.isShowPreImg = true
			},
			
			


			//排序 index是点击的项的索引,formName是属性名
			sort(index, formName) {
				//点击了默认排序
				if (index == -1) {
					this.sortIndex = -1;
					this.sortContent = ''; //排序的值 desc / esc
					this.sortFlag = true;
					//使用index把所有的搜索项值为''然后再发送请求获取到默认列表
					this.pageNumber = 1; //页码修改为1
					this.tableData = []; //表格数据修改为空
					this.searchForm.sort = ''; //排序的属性名
					this.searchForm.rule = ''; //排序的方式
					//获取默认排序的表格数据

					this.initData(); //获取默认排序的表格数据
					return
				}
				//点击还是当前搜索项那么就进行升降序切换
				if (index == this.sortIndex) {
					this.sortFlag = !this.sortFlag;
					//把当前点击的搜索项切换为desc为降序
					if (this.sortFlag) {
						this.sortContent = 'desc'; //排序的值 desc / esc
						//使用index把所有的搜索项值为''然后把当前点击的搜索项的值修改为desc
						this.pageNumber = 1; //页码修改为1
						this.tableData = []; //表格数据修改为空
						this.searchForm.sort = formName; //排序的属性名
						this.searchForm.rule = 'desc'; //排序的方式
						//获取表格列表

						this.initData(); //获取当前点击的搜索项的表格数据
					} else {
						//把当前点击的搜索项切换为esc为升序
						//使用index把所有的搜索项值为''然后把当前搜索项的值修改为asc
						this.sortContent = 'asc'; //排序的值 desc / asc
						this.pageNumber = 1; //页码修改为1
						this.tableData = []; //表格数据修改为空
						this.searchForm.sort = formName; //排序的属性名
						this.searchForm.rule = 'asc'; //排序的方式
						//获取表格列表
						this.initData(); //获取当前点击的搜索项的表格数据
					}
					return
				}
				//当前点击的搜索项是其他的搜索项
				this.sortIndex = index; //当前点击的搜索项的索引号
				this.sortContent = 'desc'; //排序的值 desc / esc
				this.sortFlag = true;
				//使用index把所有的搜索项值为''然后把当前搜索项的值修改为desc然后再发送请求获取到列表
				this.pageNumber = 1; //页码修改为1
				this.tableData = []; //表格数据修改为空
				this.searchForm.sort = formName; //排序的属性名
				this.searchForm.rule = 'desc'; //排序的方式
				//获取表格列表

				this.initData(); //获取当前点击的搜索项的排序的表格数据
			},



			//搜索
			handleSearch() {
				this.pageNumber = 1;
				this.initData()
			},

			//重置
			handleReset() {
				this.$refs.searchForm.resetFields();
				this.searchForm = {
					
				};
				this.sortIndex = -1;
				this.sortContent = ''; //排序的值 desc / esc
				this.sortFlag = true;
				this.pageNumber = 1
				this.pageSize = 10
				this.tableData = []; //表格数据修改为空
				this.initData()
			},






		}


	}
</script>

<style scoped>
	.tableTem ul {
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-wrap: wrap;

	}

	.tableTem ul li {
		list-style: none;

		width: 110px;
		min-height: 60px;
		border-left: 1px solid #ededed;
		border-bottom: 1px solid #ededed;
		margin-bottom: -1px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 3px;


	}

	.tableTem .content {

		padding-top: 3px;
		font-size: 14px;
		color: #2d8cf0;
		font-weight: 600;
	}

	.tableTem .avatar img {
		border-radius: 10px;
		width: 60px;
		height: 60px;
	}

	.tableTem .avatar {

		padding-right: 20px;
		display: flex;
		justify-content: center;

	}

	.tableTem .dian {
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100px;
	}

	.tableTem .dianL {
		text-align: left;
		font-size: 13px;
		color: #333;
	}


	.titleFont {
		font-size: 12px !important;
		flex-shrink: 0;
		line-height: 25px;
		color: rgb(136, 136, 136);
	}





	.sortLine {
		display: flex;
		align-items: center;
	}

	.sortItem {

		height: 100%;
		color: rgb(156, 156, 156);
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		min-width: 100px;
	}

	.sortItem:hover {
		background-color: #9E819F !important;
		color: #fff !important;
	}

	.sortLine .sortItem:last-child {
		border-right: none;
	}

	>>>.el-table tbody tr:hover>td {
		background-color: #ffffff !important
	}


	>>>.el-icon-arrow-down {
		font-size: 12px;
	}

	>>>.demonstration {
		display: block;
		color: #8492a6;
		font-size: 14px;
		margin-bottom: 20px;
	}

	>>>.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	>>>.el-table td {
		padding: 10px 0 !important;
	}






	.detal .title {
		color: #333333;
		margin-bottom: 24px;
		width: 100%;
		height: 16px;
		line-height: 16px;
		padding-left: 10px;
		border-left: 3px solid rgb(254, 106, 0);
		box-sizing: border-box;
		font-size: 15px;
		font-weight: bold;
	}

	.detal .order-detail {
		padding: 15px;
		box-sizing: border-box;
		background: white;
	}

	.detal .order-information>div:nth-child(1) {
		border-left: none;
	}

	.detal .order-information-contentOne {
		width: 50%;
		height: 100%;
		padding: 0 48px;
		box-sizing: border-box;
	}

	.detal .order-information {

		width: 100%;
		min-height: 40px;
		display: flex;
	}

	.detal .contentOne-content {
		display: flex;
		font-size: 14px;
		color: rgb(164, 164, 164);
		margin-bottom: 14px;
	}

	.detal .shop-information {
		width: 100%;
		background: white;
		padding: 15px;
		box-sizing: border-box;
		margin-top: 15px;
	}

	.detal .shop-information-table {
		width: 100%;
		padding: 0 48px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.detal .shop-information-table>table {
		width: 100%;
		border: 1px solid rgb(238, 238, 238);
		border-bottom: none;
	}

	.detal .table-trThree {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-top: 1px solid rgb(238, 238, 238);
		max-width: 100%;
		min-height: 40px;
		padding: 16px 28px;
		box-sizing: border-box;
		border: 1px solid rgb(238, 238, 238);
	}

	.detal .table-settlement {
		margin: 10px 0 20px;
		color: #333333;
		text-align: right;
	}

	.detal .table-trOne {
		height: 48px;
		background: rgb(245, 245, 245);
	}



	.detal .table-trTow {
		width: 100%;
		height: 60px;
		border-top: 1px solid rgb(238, 238, 238);
	}

	.detal .table-trTow>td {
		text-align: center;
		/* padding-left: 28px; */
		box-sizing: border-box;
		font-weight: 500;
		color: #333333;
		border-right: 1px solid rgb(238, 238, 238);
	}

	.detal .table-trThree>div {
		font-weight: 500;
		color: #333333;
	}

	.detal .contentOne-content-title {
		flex-shrink: 0;
	}

	.detal .table-trThree>div>p:nth-child(1) {
		margin-bottom: 8px;
	}

	.detal .table-trThree>div>p {
		color: rgb(164, 164, 164);
	}

	.detal .table-trThree>div>p {
		display: flex;
		align-items: center;
	}

	.detal .table-trThree>div>p>span {
		color: #333333;
	}

	.detal .table-settlement>span:nth-child(2) {
		color: rgb(255, 106, 0);
		font-size: 15px;
	}
</style>
